import * as React from "react";
import { TopicManagement } from "@/components/TopicManagement";

export default function ReflectionTopics() {
	return (
		<div className="container mx-auto px-4 py-8 max-w-7xl">
			<h1 className="text-2xl font-bold mb-4">Reflection Topics</h1>
			<TopicManagement />
		</div>
	);
}
